/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */


import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '@reducers/rootReducer';

import { initWizardOrderReportState } from './constants';
import { IWizardOrderReportReducer } from './reducer';
import { IWizardOrderReportValidation } from './types';

export const makeSelectWizardOrderReportState = (state: IRootReducer): IWizardOrderReportReducer =>
    state.wizardOrderReport || initWizardOrderReportState;

export const makeSelectWizardOrderReportValidation = (): OutputSelector<
    IRootReducer,
    IWizardOrderReportValidation,
    (state: IWizardOrderReportReducer) => IWizardOrderReportValidation
> => createSelector(makeSelectWizardOrderReportState, (state) => state.validation);
